import { TypographyProps } from "@mui/material";
import { ForwardedRef, forwardRef, HTMLAttributes } from "react";

import { HeroImagesTitle } from "../HeroImages";
import { HbmlElements } from "./HbmlElements";
import { hbmlNodeFactory } from "./common/hbmlNodeFactory";

export const HbmlHeroTitleNode = hbmlNodeFactory<
    typeof HbmlElements.HERO_TITLE,
    { align?: TypographyProps["align"] },
    Omit<HTMLAttributes<HTMLHeadingElement>, "color" | "content">
>({
    type: HbmlElements.HERO_TITLE,
    Component: forwardRef(function ComponentInternal({ node, ...props }, ref: ForwardedRef<HTMLDivElement>) {
        return <HeroImagesTitle style={{ textAlign: node.align }} ref={ref} {...props} />;
    }),
});
